import { ButtonBase } from "@mui/material";
import Check from "@mui/icons-material/Check";
import HourglassEmpty from "@mui/icons-material/HourglassEmpty";

// CompleteButton ticks the task off from its sheet. It says what a tap does: open, it's
// a grey outline with an hourglass reading "Mark Complete"; done, it fills green with a
// check and reads "Done". Only a done task wears green, so an open one can't be
// mistaken for it.
export function CompleteButton(props: {
    done: boolean;
    disabled?: boolean;
    onClick: () => void;
}) {
    return (
        <ButtonBase
            aria-label={props.done ? "Mark open" : "Mark complete"}
            disabled={props.disabled}
            onClick={props.onClick}
            sx={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                height: 36,
                pl: 1,
                pr: 1.5,
                borderRadius: 18,
                border: 2,
                borderColor: props.done ? "success.main" : "grey.400",
                bgcolor: props.done ? "success.main" : "transparent",
                color: props.done ? "common.white" : "text.secondary",
                fontSize: "0.875rem",
                fontWeight: 600,
                transition: "background-color 200ms, border-color 200ms, color 200ms",
            }}
        >
            {/* an open task shows it's still waiting; the check is for one that's done */}
            {props.done ? <Check sx={{ fontSize: 20 }} /> : <HourglassEmpty sx={{ fontSize: 18 }} />}
            {props.done ? "Done" : "Pending"}
        </ButtonBase>
    );
}
